/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Spaces_Chip2_LabelInputs */



/**
* | output |
* | --- |
* | "Can I connect an existing drive?" |
*
* @param {Uno_Edu_Intro_Spaces_Chip2_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_spaces_chip2_label = /** @type {((inputs?: Uno_Edu_Intro_Spaces_Chip2_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Spaces_Chip2_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kann ich ein bestehendes Laufwerk verbinden?")
	return /** @type {LocalizedString} */ ("Can I connect an existing drive?")
});